import script from "./CRMDatatableTDTaskStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMDatatableTDTaskStatus.vue?vue&type=script&setup=true&lang=js"

import "./CRMDatatableTDTaskStatus.vue?vue&type=style&index=0&id=24c8968e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c8968e"]])

export default __exports__